import { formatSportLabel } from "./utils";

/**
 * Il filtro per sport dei calendari gare (D16 di docs/sport-config).
 *
 * Una gara collegata a uno sport del catalogo si filtra per sport, qualunque
 * testo abbia: «CrossFit», «Cross Fit» e «crossfit» sono la stessa voce. Una
 * gara non collegata, di uno sport non censito, si filtra per il suo testo,
 * come prima: le gare «strane» non spariscono dal filtro.
 *
 * Valori: `sport:<slug>` per gli sport, `text:<testo minuscolo>` per il resto.
 */
const normalizeText = (value) => String(value || "").trim().toLowerCase();

export function competitionSportOptions(events, catalog = []) {
	const linked = new Map();
	const unlinked = new Map();
	(Array.isArray(events) ? events : []).forEach((event) => {
		if (event?.sport) {
			const value = `sport:${event.sport}`;
			if (!linked.has(value)) {
				const known = (catalog || []).some((item) => item?.value === event.sport);
				linked.set(value, {
					value,
					label: known
						? formatSportLabel(event.sport, catalog)
						: event.discipline || formatSportLabel(event.sport, catalog),
					linked: true,
				});
			}
			return;
		}
		const text = String(event?.discipline || "").trim();
		if (!text) return;
		const value = `text:${normalizeText(text)}`;
		if (!unlinked.has(value)) unlinked.set(value, { value, label: text, linked: false });
	});
	const byLabel = (a, b) => a.label.localeCompare(b.label, "it");
	return [
		...Array.from(linked.values()).sort(byLabel),
		...Array.from(unlinked.values()).sort(byLabel),
	];
}

export function matchesCompetitionSport(event, selected) {
	if (!selected || selected === "__all__") return true;
	if (selected.startsWith("sport:")) return event?.sport === selected.slice(6);
	if (selected.startsWith("text:")) {
		return !event?.sport && normalizeText(event?.discipline) === selected.slice(5);
	}
	return true;
}
